module.exports = __webpack_public_path__ + "img/shoerackA23.eb454f14.jpg";